import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { getTripType } from "../utils";
import { PRIORITY_BOARDING_ROUTES } from "./defines/priorityBoardingRoutes";
import { getBoundDetails } from "./priorityBoardingHelperUtils";

export function usePriorityBoardingPurchaseAnalytics(reservation) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === PRIORITY_BOARDING_ROUTES.purchase) {
      const isGetaways = reservation?.segments?.some(
        (segment) => segment?.segmentDetails?.fareFamily === "GTW"
      );
      const isInternational = reservation?.segments?.some(
        (segment) => segment?.segmentDetails?.international
      );

      setMktgPageData(
        {
          air_triptype: getTripType(reservation?.tripType),
          confirmation_number: reservation?.confirmationNumber,
          ...(isInternational ? { isinternational: "1" } : { isdomestic: "1" }),
          ...(isGetaways && { pnrisgetaways: "1" }),
          ...getBoundDetails(reservation?.segments, true),
        },
        "priorityBoardingPurchase"
      );
    }
  }, [pathname, reservation]);
}
